export default __webpack_public_path__ + "static/media/digiimg2.266ee3ac.jpg";